<template>
	<svg :width="width" :height="height" viewBox="0 0 14 10" role="presentation" xmlns="http://www.w3.org/2000/svg">
		<g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
			<g id="footer-3" transform="translate(-654.000000, -156.000000)">
				<path
					d="M654.292893,160.292893 C654.655523,159.930264 655.227368,159.904361 655.619886,160.215187 L655.707107,160.292893 L658.898888,163.484732 L666.091883,156.292893 C666.454513,155.930264 667.026358,155.904361 667.418876,156.215187 L667.506097,156.292893 C667.868726,156.655523 667.894628,157.227368 667.583803,157.619886 L667.506097,157.707107 L659.606602,165.606602 C659.243972,165.969231 658.672127,165.995134 658.279609,165.684308 L658.192388,165.606602 L654.292893,161.707107 C653.902369,161.316582 653.902369,160.683418 654.292893,160.292893 Z"
					id="Path"
					fill="#000000"
				></path>
			</g>
		</g>
	</svg>
</template>

<script>
export default {
	props: {
		type: {
			type: String,
			ddefault: "",
		},
		width: {
			type: Number,
			default: 14,
		},
		height: {
			type: Number,
			default: 10,
		},
		fill: {
			type: String,
			default: "#FF3D37",
		},
	},
};
</script>

<style scoped>
path {
	transition: all 0.3s;
}
</style>
